module.exports = __webpack_public_path__ + "static/media/pencil.886d7091.svg";